import React from 'react';
import {ThinkscapeTable} from '../../components/common';
import {Link} from '@material-ui/core';
import {fetchAnalytics} from '../../api';
import Colors from '../common/Colors';


export default function QuizStatistics(props) {
    const {quizId, showQuestionModal} = props;
    return (
        <ThinkscapeTable
            hiddenFields={['actions']}
            itemName="quizzes"
            itemsPerPage={50}
            getFieldsMapping={(record) => (
                {
                    name: record.name,
                    topic: record.topic,
                    correct: record.pValue,
                    bValue: record.biserial,
                })
            }
            fetchRecords={(args) => fetchAnalytics(quizId, {
                ...args,
            })}
            fieldsSettings={
                {
                    name: {
                        fieldText: 'Question',
                        sortable: true,
                        formatData: (cell,row) => <Link onClick={() => showQuestionModal(row)}>{cell ? cell : '-'}</Link>,
                    },
                    topic: {
                        fieldText: 'Topic',
                        sortable: true,
                    },
                    correct: {
                        sortable: true,
                        fieldText: 'Correct',
                        noPadding: true,
                        // formatData: cell => cell ? (cell*100).toFixed(0) + '%' : '-'
                        formatData: cell => {
                            if (cell != null) {
                                let percent = (cell*100).toFixed(0);
                                return ( <>
                                    <span className="outlined" style={{width:'95%', height:'15%',
                                        background: `linear-gradient(90deg, ${Colors.primary} ${percent}%, 
                                        ${Colors.contrastText} ${percent}%)`,
                                        display: 'inline-table'}}>&nbsp;</span>&nbsp;
                                    {percent + '%'}
                                </>);
                            }
                            else {
                                return '-';
                            }
                        }
                    },
                    bValue: {
                        fieldText: 'Biserial Correlation',
                        noPadding: true,
                        sortable: true,
                        formatData: (cell => cell ? cell.toFixed(3) : '-')
                    },
                }
            }
        />
    );
}
